import React from 'react';
import { useRouteError } from 'react-router-dom';
import { AppLogo } from '../components/common/AppLogo';
import ErrorFallback from '../components/common/ErrorFallback';
import ToggleTheme from '../components/common/ToggleTheme';
import { useNavigate } from 'react-router-dom';
import { WarningOutlined } from '@ant-design/icons';
import MainLayout from '../components/layout/MainLayout';
import { dashboardRoutes } from './config/dashboard.routes';
import { generateRouteChildren, getMenuItems } from '../utils/route.util';
import PageNotFound from '../components/common/PageNotFound';
import Login from '../components/auth/Login';
import { AvatarPopover } from '../components/common/AvatarPopover';
import LogoutButton from '../components/auth/LogoutButton';
import { Navigate } from 'react-router-dom';
import AuthVerify from '../components/auth/AuthVerify';
import { RequireAuth } from '../components/auth/RequireAuth';
import SysAdminTenantDropdownSelectorContainer from '@components/dashboard/sysadmin/sysadmin-tenant/containers/sysadmin-tenant-dropdown-selector.container';
import { useAuthUser } from '../states/user.atom';

// Wrapper component to access user state for menu filtering
const DashboardLayoutWrapper: React.FC = () => {
  const { isSysAdmin } = useAuthUser();

  return (
    <MainLayout
      showHeader={true}
      headerProps={{
        leftContent: <SysAdminTenantDropdownSelectorContainer />,
        rightContent: (
          <>
            <AvatarPopover extraListItems={[<ToggleTheme showText />, <LogoutButton />]} />
          </>
        ),
      }}
      menuItems={getMenuItems(dashboardRoutes, isSysAdmin())}
      showDrawer={true}
      showNav={false}
      logo={<AppLogo />}
      footerContent="©2025 Your Company Name. All Rights Reserved."
    />
  );
};

// Error boundary component to handle route errors
export const RouteErrorBoundary = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  return (
    <ErrorFallback
      error={error}
      resetErrorBoundary={() => navigate('/')}
      resetText="Back to Home"
      icon={<WarningOutlined />}
    />
  );
};

export const getAppRoutes = () => {
  return [
    {
      path: '/',
      element: <Navigate to="/dashboard" replace />,
    },
    {
      path: '/me',
      element: (
        <div>
          <AuthVerify />
        </div>
      ),
    },
    {
      path: '/login',
      element: (
        <div>
          <Login />
        </div>
      ),
    },
    {
      path: '/dashboard',
      element: (
        <RequireAuth>
          <DashboardLayoutWrapper />
        </RequireAuth>
      ),
      children: generateRouteChildren(dashboardRoutes),
    },
    {
      path: '*',
      element: <PageNotFound />,
    },
  ];
};

export const AppRoutes = getAppRoutes();
